<template>
  <v-dialog v-model="dialog" :max-width="options.width" @keydown.esc="cancel">
    <v-card>
      <v-toolbar :color="options.color" density="compact">
        <v-toolbar-title class="text-body-2 font-weight-bold text-grey" v-if="title">
          {{ title }}
        </v-toolbar-title>
        <v-toolbar-title class="text-body-2 font-weight-bold text-grey" v-if="!title">{{ $t('confirm-dialog.defaultTitle') }}</v-toolbar-title>
      </v-toolbar>
      <v-card-text v-show="!!message" class="pa-4 text-black" v-html="message"></v-card-text>
      <v-card-actions class="pt-3">
        <v-spacer></v-spacer>
        <v-btn
          v-if="!options.noconfirm"
          color="grey"
          variant="outlined"
          class="body-2 font-weight-bold"
          @click="cancel"
        >{{ $t('confirm-dialog.cancel') }}</v-btn>

        <v-btn color="primary" class="body-2 font-weight-bold" variant="flat" @click="agree">{{ $t('confirm-dialog.ok') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import { ref, reactive } from 'vue';

const dialog = ref(false);
const message = ref<string | null>(null);
const title = ref<string | null>(null);
const options = reactive({
  color: 'grey lighten-3',
  width: 400,
  zIndex: 200,
  noconfirm: false,
});

let resolvePromise: ((v: boolean) => void) | null = null;

const open = (titleText: string | null, msg: string, opts: any): Promise<boolean> => {
  dialog.value = true;
  title.value = titleText;
  message.value = msg;
  Object.assign(options, opts);
  return new Promise((resolve) => {
    resolvePromise = resolve;
  });
};

const openWithMessage = (msg: string) => {
  return open(null, msg, {});
};

const agree = () => {
  if (resolvePromise) resolvePromise(true);
  dialog.value = false;
};

const cancel = () => {
  if (resolvePromise) resolvePromise(false);
  dialog.value = false;
};

defineExpose({ open, openWithMessage });
</script>
